import React from "react";

const InfoPerson = ({ persona, onSelect }) => {
  if (!persona) return null;

  return (
    <div className="row  align-items-center mx-2 py-3 my-5">
      <div className=" col d-flex align-items-center gap-4">
        <div>
          <h2 className=" fw-bold text-dark">{persona.razonSocial.nombreCompleto}</h2>
          <p className="mt-2 fw-semibold text-dark">{persona.correoElectronico.direccion}</p>
        </div>
      </div>
      <div className="mt-3 col">
        <button className="btn btn-primary " onClick={onSelect}>
          Seleccionar
        </button>
      </div>
    </div>
  );
};

export default InfoPerson;
